<div class="satellite-report-request-container">
    <form [formGroup]="filterForm" (ngSubmit)="sendSatelliteReportRequest()">

        <h2 class="label-header" style="font-weight: bold; font-size: medium;">{{
            'DOWNLOAD-SATELLITE-REPORT-DIALOG.TITLE' | translate }}</h2>
        <div class="filter-datepicker-container">
            <mat-form-field [floatLabel]="'always'" id="date-picker" class="my-order-filter-cal-input"
                appearance="outline">
                <mat-label>Date Range</mat-label>
                <mat-date-range-input class="datepicker" [rangePicker]="rangePicker">
                    <input formControlName="filterStartDate" matStartDate [value]="startDate" style="font-size: 11px;">
                    <input formControlName ="filterEndDate" matEndDate [value]="endDate" style="font-size: 11px;">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker>
                    <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel
                            class="cancel-date-picker default-btn-variant">CLOSE</button>
                        <button (click)="setFilterDates()" mat-raised-button matDateRangePickerApply
                            class="apply-date-picker default-btn">APPLY
                        </button>
                    </mat-date-range-picker-actions>
                </mat-date-range-picker>
            </mat-form-field>

        </div>

        <div class="satellite-report-btn-container">
            <button mat-flat-button (click)="cancel()" type="button" class="buttons field-cancel-btn">{{
                'DOWNLOAD-SATELLITE-REPORT-DIALOG.CANCEL' |
                translate }}</button>
            <button mat-flat-button style="width: 40%;" type="submit" class="buttons field-add-btn"
            (click)="applyFileringMyOrders()">{{
                'DOWNLOAD-SATELLITE-REPORT-DIALOG.CREATE' |
                translate }}</button>
        </div>


    </form>
</div>